/**
 * Labstep
 *
 * @module components/Organization/Settings/Sso
 * @desc Displays whether organization SSO is enabled or disabled
 */

import { OrganizationPremiumFeatureToggle } from 'labstep-web/components/Organization/PremiumFeatureToggle';
import { OrganizationSAMLActionCreate } from 'labstep-web/components/OrganizationSAML/Action/Create';
import { OrganizationSAMLShow } from 'labstep-web/components/OrganizationSAML/Show';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Checkbox } from 'labstep-web/core/Checkbox';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { OrganizationSettingsSsoProps } from './types';

export const OrganizationSettingsSso: React.FC<
  OrganizationSettingsSsoProps
> = ({ organization }) => {
  if (!organization.hasFeatureEnabled('sso')) {
    return <OrganizationPremiumFeatureToggle premiumFeature="sso" />;
  }
  return (
    <div>
      <OrganizationSAMLActionCreate
        organization={organization}
        actionComponentProps={{
          type: 'checkbox',
          elementProps: {
            checked: !!organization.organization_saml,
            disabled: organization.organization_saml?.is_enabled,
            toggle: true,
          },
        }}
      />
      {organization.organization_saml && (
        <div>
          {organization.organization_saml.is_enabled ? (
            <Checkbox toggle checked disabled />
          ) : (
            <ModalDefault
              header="SSO Details"
              content={
                <OrganizationSAMLShow organization={organization} />
              }
              size="large"
              viewComponent={({
                toggleModal,
              }): React.ReactElement => (
                <ActionComponent
                  type="text"
                  text="Setup Details"
                  onClick={toggleModal}
                />
              )}
            />
          )}
        </div>
      )}
    </div>
  );
};
